// Harici Personel Yönetimi (/external-personnel-management). Kayıtlı değerler
// yazıldığı gibi gösterilir; Excel başlıkları Türkçe alan adlarıdır.
const externalPersonnel = {
  page: {
    title: 'Harici Personel Yönetimi',
    subtitle: 'Kurum dışı personel (araştırmacı, koordinatör vb.) iletişim ve görev bilgileri.',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Tüm harici personeli tabloda görünen sütunlarla Excel olarak indir',
    add: 'Yeni Harici Personel Ekle',
  },
  stats: {
    total: 'Toplam Harici Personel',
    totalShort: 'Toplam',
    active: 'Aktif Personel',
    activeShort: 'Aktif',
    inactive: 'İnaktif Personel',
    inactiveShort: 'İnaktif',
    share: 'Personelin %{{percent}}’i',
  },
  toolbar: {
    search: 'İsim, soyisim veya telefon ile ara…',
    searchShort: 'Personel ara…',
    status: 'Durum',
    all: 'Tümü',
  },
  status: {
    aktif: 'Aktif',
    inaktif: 'İnaktif',
  },
  fields: {
    name: 'Adı',
    surname: 'Soyadı',
    address: 'Adres',
    phone: 'Telefon',
    email: 'E-posta',
    institution: 'Kurum',
    title: 'Ünvan',
    specialty: 'Uzmanlık',
    department: 'Ana Bilim Dalı',
    personnelType: 'Personel Tipi',
    status: 'Durum',
    info: 'Bilgi',
  },
  table: {
    listLabel: 'Harici personel',
    empty: 'Filtrelere uygun personel bulunamadı',
    rangeOf: '/ {{total}} personel',
    ofTotal: 'toplam {{total}} personel içinden',
    jump: 'Sayfaya git',
  },
  panel: {
    label: 'Seçili personel',
    heading: 'Harici personel',
    edit: 'Düzenle',
  },
  form: {
    newTitle: 'Yeni Harici Personel Ekle',
    editTitle: 'Harici Personel Düzenle',
    subtitle: 'Tüm alanların doldurulması zorunludur.',
    sections: {
      contact: 'Kişi ve iletişim',
      work: 'Kurum ve görev',
    },
    required: 'Bu alan zorunludur',
    missing: 'Eksik bilgiler — lütfen şu alanları doldurun: {{fields}}',
  },
  common: {
    cancel: 'İptal',
    save: 'Kaydet',
  },
  toast: {
    loadError: 'Dış personeller yüklenirken hata oluştu',
    added: 'Harici personel başarıyla eklendi!',
    addError: 'Harici personel eklenirken bir hata oluştu!',
    updated: 'Harici personel başarıyla güncellendi!',
    updateError: 'Harici personel güncellenirken bir hata oluştu!',
    excelPreparing: 'Excel dosyası hazırlanıyor…',
    excelDone: 'Excel dosyası başarıyla indirildi',
    excelError: 'Dosya indirilirken hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default externalPersonnel;
